import { useAuthState, ContextHolder } from "@frontegg/react";
import Login from "../pages/auth/login";
import { usePreviewSession } from "../contexts/PreviewSessionContext";

const DEV_AUTH_BYPASS = import.meta.env.DEV && import.meta.env.VITE_DEV_AUTH_BYPASS === "true";

export function useAuthCheck() {
  const previewCtx = usePreviewSession();
  // Whether a PreviewSessionProvider is mounted is stable for a given app
  // instance (decided at the top of main.tsx), so the conditional below does
  // not violate the React rules of hooks across renders.
  const inPreview = !!previewCtx;
  const fronteggState = inPreview ? null : useAuthState();

  if (inPreview) {
    if (previewCtx!.loading) {
      return { isLoading: true, component: <div>Loading preview…</div> };
    }
    if (previewCtx!.error || !previewCtx!.session) {
      return {
        isLoading: false,
        component: (
          <div className="fixed inset-0 bg-[#05050F] flex items-center justify-center p-6">
            <div className="text-center max-w-md">
              <h1 className="text-white text-xl font-semibold mb-3">Preview Unavailable</h1>
              <p className="text-[#6B96D6] text-sm">
                {previewCtx!.error || "This preview link is no longer valid."}
              </p>
            </div>
          </div>
        ),
      };
    }
    return { isLoading: false, component: null };
  }

  if (DEV_AUTH_BYPASS) {
    return { isLoading: false, component: null };
  }

  const isContextReady = Boolean(ContextHolder.getContext());
  const isAuthenticated = fronteggState?.isAuthenticated ?? false;
  const isLoading = fronteggState?.isLoading ?? true;

  if (!isContextReady || isLoading) {
    return { isLoading: true, component: <div>Loading...</div> };
  }

  if (!isAuthenticated) {
    return { isLoading: false, component: <Login /> };
  }

  return { isLoading: false, component: null };
}
